import React, {Component} from 'react'
import PropsTypes from "prop-types"
import {Alert, Modal} from "reactstrap"
import ProxiesPagination from "./ProxiesPagination"
import ProxyRecord from "./ProxyRecord"
// import CreateNewProxy from "./CreateNewProxy"
import ProxyStatistics from "./ProxyStatistics"
import CreateNewBulkProxies from "./CreateNewBulkProxies";
import UpdateProxyDataForm from "./UpdateProxyDataForm";

class ProxiesPage extends Component {
    render() {
        const {total, pagination, error, docs, isModalOpen} = this.props;
        return (
            <div className='BillingPage'>
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Proxy ({total})</h2>
                <div>
                    <div className='row'>
                        {/*<CreateNewProxy onRefreshPage={this.props.onRefreshPage}/>*/}
                        <CreateNewBulkProxies onRefreshPage={this.props.onRefreshPage}/>
                        <ProxyStatistics/>
                    </div>
                    <div className='row table-row'>
                        <div className='col'>Score</div>
                        <div className='col'>URI</div>
                        <div className='col'>Used</div>
                        <div className='col'>Verified</div>
                        <div className='col'>Country</div>
                        <div className='col note'>Note</div>
                        <div className='col'>Status</div>
                        <div className='col'>Delete</div>
                    </div>
                    {
                        docs.map(record => {
                            return <ProxyRecord key={record._id} record={record}
                                                onRefreshPage={this.props.onRefreshPage}
                                                removeProxyFromState={this.props.removeProxyFromState}
                                                onToggleModal={this.props.onToggleModal}
                                                onChangeModalData={this.props.onChangeModalData}
                            />
                        })
                    }
                </div>
                <ProxiesPagination paginationInfo={pagination} onChangePage={this.props.onChangePage}/>
                <Modal isOpen={isModalOpen} toggle={this.props.onToggleModal} className={this.props.className}>
                    <UpdateProxyDataForm
                        onToggleModal={this.props.onToggleModal}
                        modalData={this.props.modalData}
                        onChangeModalData={this.props.onChangeModalData}
                        onUpdateListProxy={this.props.onUpdateListProxy}
                        onCloseModal={this.props.onCloseModal}
                    />
                </Modal>
            </div>
        )
    }
}

ProxiesPage.propsTypes = {
    removeProxyFromState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    onChangePage: PropsTypes.func.isRequired,
    total: PropsTypes.number,
    pagination: PropsTypes.object.isRequired,
    error: PropsTypes.string,
    docs: PropsTypes.array.isRequired,
    isModalOpen: PropsTypes.bool.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    modalData: PropsTypes.func.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
    onCloseModal: PropsTypes.func.isRequired,
    onUpdateListProxy: PropsTypes.func.isRequired
}
export default ProxiesPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/ProxiesPage.js